// this determines how the available search options are returned
export enum SearchOptionType {
    // primary: if the first search criterion is not Primary, then NO primary search options are returned, otherwise all options are returned
    primary,
    // filter: will never return the same option twice
    filter,
    // determine: returns matching criterion's matching option if criterion is disabled, else it returns all options with shouldHide = false
    determine,
}
